class FanDispatchCountdown extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-countdown]');
    this.cutoffHour = Number(this.dataset.cutoffHour || 16);
    this.update();
    this.timer = window.setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  update() {
    if (!this.output) return;

    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(this.cutoffHour, 0, 0, 0);

    if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);

    const remainingSeconds = Math.max(0, Math.floor((cutoff - now) / 1000));
    const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(remainingSeconds % 60).padStart(2, '0');

    this.output.textContent = `${hours}:${minutes}:${seconds}`;
  }
}

if (!customElements.get('fan-dispatch-countdown')) {
  customElements.define('fan-dispatch-countdown', FanDispatchCountdown);
}

class FanOrdersToday extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min || 40);
    const max = Number(this.dataset.max || 120);
    const productId = this.dataset.productId || window.location.pathname;
    const now = new Date();
    const date = [
      now.getFullYear(),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0'),
    ].join('-');
    const storageKey = `fan-orders-today:${productId}:${date}`;
    let count;

    try {
      const storedCount = Number(window.localStorage.getItem(storageKey));
      if (Number.isInteger(storedCount) && storedCount >= min && storedCount <= max) {
        count = storedCount;
      } else {
        count = Math.floor(Math.random() * (max - min + 1)) + min;
        window.localStorage.setItem(storageKey, String(count));
      }
    } catch (_error) {
      count = Math.floor(Math.random() * (max - min + 1)) + min;
    }

    this.textContent = String(count);
  }
}

if (!customElements.get('fan-orders-today')) {
  customElements.define('fan-orders-today', FanOrdersToday);
}
